import "swiper/swiper.min.css";
import "./assets/boxicons-2.0.7/css/boxicons.min.css";
import "./App.scss";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import Detail from "./pages/detail/Detail";
import ErrorPage from "./components/error/Error";

function App() {
  return (
    <Router>
      <Header />
      <Route>
        <Switch>
          <Route path="/:category/search/:keyword" component={Catalog} />
          <Route path="/:category/:id" component={Detail} />
          <Route path="/:category" exact component={Catalog} />
          <Route path="/" exact component={Home} />
          <Route path="*" component={ErrorPage} />
        </Switch>
      </Route>
      <Footer />
    </Router>
  );
}

export default App;
